<div aria-label="taskTableHeader" role="tabpanel" style="pointer-events: auto;">
  <div style="position: absolute; margin-top: 12px; margin-left: 225px;">
    <span *ngIf="loading" class="spinner-border spinner mr-1 mt-1"></span>
  </div>

  <app-configurable-header 
    (actionOne)="exportData()"
    (actionTwo)="toggleUpdateForm()"
    (actionThree)="closeSmartTable()"
    (checkboxClick)="assignedToChanged($event)"
    [checkboxChecked]="assignedToMeChecked"
    [checkboxlabel1]="'My-maintenance.input.assigntome' | translate " 
    [headingText]="'Make'" 
    [iconOne]="'download'"
    [iconTwo]="'pencil'"
    [iconThree]="'cross'"
    [iconTwoDropdown]="false"
    [isMakeViewerHeader]="true"
    [tooltipOne]="'Download'"
    [tooltipThree]="'Close'"
    [tooltipTwo]="'Edit'"
    [variant]="'none'" > 
  </app-configurable-header>
    
  <div class="row" role="table">
    <div class="col-12">
      <div style="background-color: Gray 10">
        <div style="display: flex; flex-direction: row">
          <div class="makeViewer" style="overflow: hidden; flex-grow: 1">
            <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="tabChanged($event)">

              <!--  tab --, "Orders">  -->
              <mat-tab label="Orders" *ngIf="!ordersHidden">  <!-- OR [disabled]="ordersHidden?? -->
                  <ag-grid-angular
                    #agOpenGrid
                    id="gridOrders" 
                    style="width: 100%;height:229px !important;"
                    class="ag-theme-balham mtTableHeight"
                    [columnDefs]="columnDefsOrders"
                    [defaultColDef]="defaultColDef"
                    [pagination]="pagination"
                    [paginationPageSize]="pagPageSize"
                    [rowData]="rowDataOrders"
                    [rowSelection]="rowSelection"
                    [gridOptions]="gridOptions"
                    (filterChanged)="onGridFilterChanged($event)"
                    (gridReady)="onGridReady($event, 'Orders')" 
                    (selectionChanged)="onGridSelectionChanged($event)"
                    (columnMoved)="onGridColumnMoved($event)"
                    (columnResized)="onGridColumnResized($event)"
                    >
                  </ag-grid-angular>
              </mat-tab>
               
              <!-- Tracking tab -->
              <mat-tab label="Tracking" *ngIf="!trackingHidden">
                <ag-grid-angular
                  #agClosedGrid
                  id="gridTracking"
                  style="width: 100%;height:229px !important;"
                  class="ag-theme-balham mtTableHeight"
                  [columnDefs]="columnDefsTracking"
                  [defaultColDef]="defaultColDef"
                  [pagination]="pagination"
                  [paginationPageSize]="pagPageSize"
                  [rowData]="rowDataTracking"
                  [rowSelection]="rowSelection"
                  [gridOptions]="gridOptions"
                  (gridReady)="onGridReady($event, 'Tracking')"
                  (filterChanged)="onGridFilterChanged($event)"
                  (selectionChanged)="onGridSelectionChanged($event)"
                  (columnMoved)="onGridColumnMoved($event)"  
                  (columnResized)="onGridColumnResized($event)"
                  >
                </ag-grid-angular>
              </mat-tab>

              <!-- History tab -->
              <mat-tab label="History" *ngIf="!historyHidden">
                <ag-grid-angular
                  #agClosedGrid
                  id="gridHistory"
                  style="width: 100%;height:229px !important;"
                  class="ag-theme-balham mtTableHeight"
                  [columnDefs]="columnDefsHistory"
                  [defaultColDef]="defaultColDef"
                  [pagination]="pagination"
                  [paginationPageSize]="pagPageSize"
                  [rowData]="rowDataHistory"
                  [rowSelection]="rowSelection"
                  (gridReady)="onGridReady($event, 'History')"
                  (filterChanged)="onGridFilterChanged($event)"
                  (selectionChanged)="onGridSelectionChanged($event)" 
                  (columnMoved)="onGridColumnMoved($event)" 
                  (columnResized)="onGridColumnResized($event)"
                  >
                </ag-grid-angular>
              </mat-tab>

            </mat-tab-group>
          </div>

          <!--<div style="border-right:thin solid lightgray; background-color: white;"></div> -->

          <div *ngIf="showForms" style="width:200px">

            <!-- Update Fab Form -->
            <div *ngIf="showUpdateForm" class="update-form">
              <div class="card">
                
                <div class="update-task-header" >
                  <div>Update</div>

                  <div *ngIf="activeTab=='Orders'" style="height:20px; margin-top:0px; border-left: 1px solid silver; border-bottom: 1px solid silver; padding-left:3px;"> <!-- display:flex; justify-content:end; -->
                    <label class="control-label" for="chkQuickEdit" style="margin-right:3px; margin-bottom: 2px; font-size: smaller;">filter Detail</label>
                    <input type="checkbox" id="chkQuickEdit" [checked]="quickEdit" (change)="toggleQuickEdit()">
                  </div>

                </div>

                <div class="update-task-dropdown-inputs" id="updateTaskInputs" style="height: 230px; overflow-y: auto; overflow-x:hidden;">

                  <app-dropdown class="makeDropdown" [label]="'Assigned To'" [dropdownList]="clientUsersList" [val]="fabWorker" [isWorkerUsername]="true" (select)="setWorker($event)"> </app-dropdown>
                  <app-dropdown class="makeDropdown" [label]="'Location'" [dropdownList]="LocationList" [val]="fabLocation" (select)="setLocation($event)"> </app-dropdown>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ "Select.manageworkorder.comments" | translate }}</mat-label>
                    <input matInput [(ngModel)]="fabComment" type="text" rows="3" name="comment" style="font-size:16px;"/>
                    <mat-error>Error</mat-error>
                  </mat-form-field>

                  <div style="display: flex; justify-content: space-between; width:100%; flex-wrap: wrap;">
                    <div *ngIf="ordersHidden == false && ordersReadOnly == false" style="margin-top:15px;">
                      <input type="checkbox" id="chkMade" *ngIf="showMadeCheckbox" name="Made" [checked]="madeCheckbox" (click)="madeClicked(this)">
                      <label class="control-label" for="chkMade" style="margin-left:3px">Made</label>
                    </div>
                    <button title="'Update'" style="margin: 4px" mat-button class="h7 primary-button" (click)="updateClicked($event)">{{fabUpdateButtonLabel}}</button>
                  </div>

                </div>
              </div>
            </div>

            <!-- Grid Managment/column picker form -->
            <div *ngIf="showGridManagementForm" class="update-form">
              <div class="card">
                <div class="update-task-header">Columns</div>
                <div style="height: 220px; overflow-y: auto; overflow-x:hidden; padding:15px; ">
                  <!--{{ allColumns | json }}-->
                  <div *ngFor="let col of allColumns;">
                    <input type="checkbox" id="chk{{col.colId}}" [checked]=col.visible (change)="colVisibilityClicked(col.colId, $event)">
                    <label class="control-label" for="chk{{col.colId}}" style="margin-left:3px">{{col.colId}}</label>
                  </div>
                  <div class="form-row d-flex justify-content-center mt-3">
                    <button title="'Reset'" style="margin: 4px" mat-button class="h7 primary-button" (click)="resetGridState()">Reset</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- History filter form -->
            <div *ngIf="showDatesForm" class="update-form">
              <div class="card">
                <div class="update-task-header">Fab Date Range</div>
                <div class="update-task-dropdown-inputs" id="updateTaskInputs">
                  <mat-form-field appearance="outline"> <!-- style="width:150px;"-->
                    <mat-label>{{ "Systemreports.activitybyreason.fromdate" | translate }}</mat-label>
                    <input matInput [matDatepicker]="picker1" autocomplete="off" [(ngModel)]="startDate" [max]="endDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline"> <!-- style="width:150px;"-->
                    <mat-label>{{ "Systemreports.activitybyreason.todate" | translate }}</mat-label>
                    <input matInput [matDatepicker]="picker" autocomplete="off" [(ngModel)]="endDate" [min]="startDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <!-- <div class="divider"></div> -->
                  <div style="display: flex; justify-content: end; width:100%">  <!--class="form-row d-flex justify-content-end mt-3"> -->
                    <button title="'Update'" style="margin: 4px" mat-button class="h7 primary-button" (click)="updateHistoryRange()">Show Data</button>
                  </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>